"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTransactionSetupFromJsonToXml = void 0;
const fast_xml_parser_1 = require("fast-xml-parser");
const enums_1 = require("../../enums");
const convertTransactionSetupFromJsonToXml = (params) => {
    const builder = new fast_xml_parser_1.XMLBuilder({ ignoreAttributes: false });
    const formattedTransactionAmount = parseFloat(`${params.transaction.TransactionAmount}`).toFixed(2);
    const input = {
        TransactionSetup: {
            Credentials: params.credentials,
            Application: params.application,
            TransactionSetup: {
                TransactionSetupMethod: enums_1.TransactionSetupMethod.CREDIT_CARD_SALE,
                DeviceInputCode: enums_1.DeviceInputCode.KEYBOARD,
                Device: enums_1.Device.DEFAULT,
                Embedded: 0,
                CVVRequired: 1,
                AutoReturn: 1,
                ProcessTransactionTitle: 'Submit',
                ...params.transactionSetup,
            },
            PaymentAccount: {
                PaymentAccountType: enums_1.PaymentAccountType.CREDIT_CARD,
                ...params.paymentAccount,
            },
            Address: params.address,
            Transaction: {
                MarketCode: enums_1.MarketCode.ECOMMERCE,
                DuplicateCheckDisableFlag: 1,
                ...params.transaction,
                TransactionAmount: formattedTransactionAmount,
            },
            Terminal: {
                CardholderPresentCode: enums_1.CardholderPresentCode.ECOMMERCE,
                CardInputCode: enums_1.CardInputCode.MANUAL_KEYED,
                CardPresentCode: enums_1.CardPresentCode.NOT_PRESENT,
                CVVPresenceCode: enums_1.CVVPresenceCode.PROVIDED,
                TerminalID: 0,
                MotoECICode: enums_1.MotoECICode.NON_AUTHENTICATED_SECURE_ECOMMERCE_TRANSACTION,
                TerminalCapabilityCode: enums_1.TerminalCapabilityCode.KEY_ENTERED,
                TerminalEnvironmentCode: enums_1.TerminalEnvironmentCode.ECOMMERCE,
                TerminalType: enums_1.TerminalType.ECOMMERCE,
            },
            '@_xmlns': 'https://transaction.elementexpress.com',
        },
    };
    const xml = builder.build(input);
    return xml;
};
exports.convertTransactionSetupFromJsonToXml = convertTransactionSetupFromJsonToXml;
//# sourceMappingURL=convertTransactionSetupFromJsonToXml.js.map